import { Injectable } from '@angular/core';
import {URLSearchParams, Http} from "@angular/http";
import {Observable} from  "rxjs/Observable";
import {HttpService} from "./http-service";
import {LoadingService} from "./loading-service";
import {AuthStore} from '../stores/auth-store';
import 'rxjs/add/operator/map';

/*
  Generated class for the AuthService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class AuthService extends HttpService {

  constructor(protected http: Http, protected loadingService:LoadingService, protected authStore:AuthStore) {
    super(http, loadingService, authStore);
  }

  /**
   * 認証処理
   */
  auth(data:object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/auth/login");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * パスワード変更
   * @param id 
   * @param pass 
   */
  passwordUpdate(id, pass){

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/users/passwordUpdate");
    var options = super.buildParam(userParam);

    return super.post(options, {id:id, pass:pass});
  }

  /**
   * パスワード忘れ申請
   */
  forgotPasswordRequest(mail){

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/users/forgotPasswordRequest");
    var options = super.buildParam(userParam);

    return super.post(options, { mail: mail });
  }

  /**
   * パスワード忘れ申請
   */
  passwordUpdateCommit(mail, reset_token, password){

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/users/passwordUpdate");
    var options = super.buildParam(userParam);

    return super.post(options, { mail: mail, reset_token: reset_token, pass: password });
  }
}


// WEBPACK FOOTER //
// ./src/providers/auth-service.ts